import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

const TemperatureOutlinedSvg = () => (
  <svg
    height="1.4em"
    width="1.4em"
    viewBox="0 0 495 570"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <g transform="translate(0,570) scale(0.1,-0.1)">
      <path
        d="M2395 5390 c-83 -11 -168 -45 -247 -97 -110 -72 -186 -171 -230 -303
        -22 -64 -22 -73 -25 -755 -3 -812 4 -1245 22 -1245 7 0 27 30 46 67 21 41 64
        99 111 149 l77 81 3 799 3 799 26 56 c36 76 90 133 157 166 81 39 192 40 274
        1 69 -32 136 -97 169 -163 l24 -50 3 -806 2 -807 45 -36 c52 -43 120 -129 160
        -203 58 -108 56 -143 53 925 l-3 977 -27 69 c-98 254 -370 413 -643 376z"
      />

      <path
        d="M2419 4525 c-62 -33 -59 -7 -60 -667 l-2 -602 -76 -37 c-124 -61
        -219 -179 -237 -295 l-6 -41 -71 1 -72 1 -3 -77 -3 -78 74 0 74 0 12 -54 c30
        -137 150 -262 293 -310 16 -5 17 -25 15 -242 l-2 -237 -35 -12 c-124 -43 -239
        -140 -297 -250 -107 -204 -76 -451 78 -619 66 -72 121 -110 206 -142 83 -31
        212 -42 296 -25 190 40 362 206 412 396 67 258 -83 538 -336 630 l-64 23 0
        237 0 237 45 15 c61 21 143 77 180 123 39 49 81 140 87 191 l6 39 79 0 79 0
        -3 78 -3 77 -74 0 -74 0 -13 54 c-38 147 -141 253 -296 305 -17 5 -18 43 -18
        606 0 659 1 643 -60 675 -36 19 -97 19 -131 0z"
      />

      <path
        d="M1900 2406 l0 -234 -49 -36 c-103 -76 -221 -228 -282 -364 -155 -345
        -92 -769 157 -1053 188 -215 433 -331 734 -346 481 -24 909 308 1017 791 21
        95 21 298 -1 393 -22 99 -67 213 -120 304 -48 82 -178 227 -245 274 l-41 28 0
        239 c0 268 -2 273 -58 172 -48 -84 -107 -158 -157 -196 l-44 -33 0 -170 0
        -170 60 -40 c191 -127 316 -346 326 -575 4 -92 2 -116 -22 -195 -35 -120 -92
        -214 -185 -307 -63 -61 -96 -85 -171 -122 -131 -63 -201 -79 -334 -79 -130 1
        -206 18 -315 73 -283 142 -439 460 -375 762 37 178 150 345 303 448 l51 35 1
        171 0 172 -46 38 c-55 44 -119 129 -154 202 -45 94 -50 76 -50 -182z"
      />
    </g>
  </svg>
);

export const TemperatureOutlined = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={TemperatureOutlinedSvg} {...props} />
);
